import { Action } from '@ngrx/store';
import * as ReqQuoteCalculationActions from './../actions/request-quote-calculation.actions';

export type Actions = ReqQuoteCalculationActions.Actions;

export function ReqQuoteCalculationReducer(state = [], action: ReqQuoteCalculationActions.Actions) {
    switch (action.type) {
        case ReqQuoteCalculationActions.ADD_REQ_QUOTE_CALCULATION:
            return [...state, action.payload];

        // Add this case:
        case ReqQuoteCalculationActions.REMOVE_REQ_QUOTE_CALCULATION:
            state = [];
            return state;

        default:
            return state;
    }
}
